import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Button from '@react/react-spectrum/Button'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'

export default function LinkButton (props) {
    const { referrer, url, target, isDisabled } = props
    const { ut } = useContext(EasybakeContext)

    function go (e) {
        analytics.sendEventName('click', `${referrer}:gotoioconsole`)
        window.open(
            url,
            target
        )
    }

    function getIsDisabled() {
        if (!ut) {
            return true
        }
        if (isDisabled) {
            return true
        }
    }

    return (
        <Button 
            {...props}
            label={__('console_get_started_manage_go')}
            disabled={getIsDisabled()} 
            variant="primary" 
            onClick={(e) => go(e)}
        />
    )
}
